import { render, staticRenderFns } from "./knowledgeModal.vue?vue&type=template&id=694281f3&scoped=true"
import script from "./knowledgeModal.vue?vue&type=script&lang=js"
export * from "./knowledgeModal.vue?vue&type=script&lang=js"
import style0 from "./knowledgeModal.vue?vue&type=style&index=0&id=694281f3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "694281f3",
  null
  
)

export default component.exports